import { ApiFailure } from '../../lib/api';

/** Message keys for the operator writes' problem answers. */
const KEYS: Record<string, string> = {
  'operator-exists': 'operators.inviteForm.exists',
  'last-owner': 'operators.lastOwner',
  'not-found': 'operators.notFound',
  'operator-disabled': 'operators.resendDisabled',
  'rate-limited': 'common.rateLimited',
  network: 'common.errorNetwork',
};

export function operatorFailureKey(error: unknown, mailFailedKey: string): string {
  const slug = error instanceof ApiFailure ? error.slug : 'unexpected';
  if (slug === 'email-delivery-failed') return mailFailedKey;
  return KEYS[slug] ?? 'common.errorUnexpected';
}
